var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-off"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.70292 9.70476C9.35915 10.0486 9.16608 10.515 9.16616 11.0012C9.16625 11.4875 9.35949 11.9538 9.70338 12.2975C10.0473 12.6413 10.5136 12.8344 10.9999 12.8343C11.4861 12.8342 11.9524 12.641 12.2962 12.2971M15.2909 15.2836C14.0051 16.0881 12.5168 16.51 11 16.5C7.7 16.5 4.95 14.6667 2.75 11C3.916 9.05667 5.236 7.6285 6.71 6.7155M9.33167 5.665C9.88078 5.55384 10.4397 5.49855 11 5.5C14.3 5.5 17.05 7.33333 19.25 11C18.6395 12.0175 17.9859 12.8948 17.2902 13.6308M2.75 2.75L19.25 19.25",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.bcfbb0cc3356cd76fa9281b96b8d15bf.svg";
export { ForwardRef as ReactComponent };